import "YesNo.js";
import "GIS/Data/Layers";
import "GIS/Geometry";
import "GIS/Data/Projections";
import "Data/ServerSource";
import "./Objects";
import { InvalidArgumentError } from '../../errors';

/** @namespace Spatial.Data */
NS("Spatial.Data");

/**
 * Spatial.Data.Classes source
 * @class
 * @extends Data.ServerSource
 */
Spatial.Data.Classes = Class(Data.ServerSource, /** @lends Spatial.Data.Classes.prototype */{
    url: "Spatial/Web/Classes/",

    fields: [
        { name: "id", title: "id" }, // int
        { name: "codeid", title: "codeid" }, // string
        { name: "name", title: "name" }, // string
        { name: "description", title: "description" }, // string
        { name: "providerid", title: "providerid" }, // int
        { name: "geomtype", title: "geomtype", enum: "GIS.Geometry" }, // int
        { name: "private", title: "private", enum: "YesNo" }, // int
        { name: "mapreports", title: "mapreports" }, // json
    ],

    create() {
        return {
            ...this.ParentCall(),
            name: "Новый класс",
            private: YesNo.No
        };
    },
    /**
     * @param {Object} item
     * @returns {{class: *, options: *}}
     * @throws InvalidArgumentError
     */
    toLayerOptions(item) {
        assert(_.isObject(item) && !_.isEmpty(item) && !_.isEmpty(item.layer), "invalid or empty item", InvalidArgumentError);

        const useCluster = GIS.Geometry.simpleName(item.geomtype) === 'point';

        item = {
            ds: new Spatial.Data.Objects(),
            dsMethod: 'findForMap',
            clusterDistance: useCluster ? 40 : undefined,
            ...item.layer,
            ...item
        };

        return new GIS.Data.Layers().toLayerOptions(item);
    }
});
